const removeQueryParameter = () => {
  window.history.replaceState(null, '', document.location.pathname)
}

export default removeQueryParameter
